import EFPicture from 'elem/compCommon/EFPicture';
import { ReactNode } from 'react';
import { FormatMoneyLocal } from '@elem/compCommon/ShopifyShoppingCart/const';
import css from './index.module.scss';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import { saveAICookieForShopify, saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

interface ProductBundlesProps {
    /** 字段使用的语言包 */
    langKey: string;
    /** 外部自定义 buy now 按钮 */
    buyComponents?: (bundle: any, oldBuyElem: ReactNode) => ReactNode;
    /** 是否启用 shipping 文案 */
    shipping?: boolean;
    callbackLink?: (link: string) => void;
    callbackButton?: (link: number) => void;
    customize?: any;
    bundles: any;

    // 特殊情况使用 variantImg
    variantImg?: boolean;
}

export default function ProductBundles({
    variantImg,
    bundles,
    customize,
    shipping,
    langKey,
    callbackLink,
    callbackButton,
    buyComponents,
}: ProductBundlesProps) {
    const { useState, useEffect, useLang, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang(langKey);
    const { t: s } = useLang('shared.product.bundles');
    const { locale, pathname } = useRouter();
    const [cardBundles, setCardBundles] = useState(bundles);
    const ISDpuCa = locale === 'ca' && pathname === '/delta-pro-ultra';

    const handleCalculate = (data: any, n: number, type: 'subs' | 'installs') => {
        const tempBundles = JSON.parse(JSON.stringify(cardBundles));
        const parentIdx = tempBundles?.findIndex((bundle: any) => bundle?.variantId === data?.parentVariantId);
        if (parentIdx !== -1) {
            const subIdx =
                type === 'subs'
                    ? tempBundles[parentIdx]?.subs?.findIndex((sub: any) => sub?.variantId === data?.variantId)
                    : tempBundles[parentIdx]?.installs?.findIndex((sub: any) => sub?.variantId === data?.variantId);

            if (subIdx !== -1) {
                if (type === 'subs') {
                    tempBundles[parentIdx].subs[subIdx] = { ...data, quantity: n };
                } else if (type === 'installs') {
                    tempBundles[parentIdx].installs[subIdx] = { ...data, quantity: n };
                }

                // 总价格
                let tempDiscount = 0,
                    tempOriginal = 0;
                tempBundles[parentIdx].subs?.map((cart: any) => {
                    if (cart?.quantity && cart?.quantity > 0) {
                        tempDiscount += cart?.discountPrice * cart?.quantity;
                        tempOriginal += cart?.originalPrice * cart?.quantity;
                    }
                });
                tempBundles[parentIdx].installs?.map((cart: any) => {
                    if (cart?.quantity && cart?.quantity > 0) {
                        tempDiscount += cart?.discountPrice * cart?.quantity;
                        tempOriginal += cart?.originalPrice * cart?.quantity;
                    }
                });

                tempBundles[parentIdx].totalDiscount = tempBundles[parentIdx].discountPrice + tempDiscount;
                tempBundles[parentIdx].totalOriginal = tempBundles[parentIdx].originalPrice + tempOriginal;

                // 购买链接
                let link = `https://${locale}.ecoflow.com/cart/${data.parentVariantId}:1`;
                tempBundles[parentIdx].subs?.map((cart: any, k: number) => {
                    if (cart?.quantity && cart?.quantity > 0) {
                        link += `,${cart?.variantId}:${cart?.quantity}`;
                    }
                });
                tempBundles[parentIdx].installs?.map((cart: any, k: number) => {
                    if (cart?.quantity && cart?.quantity > 0) {
                        link += `,${cart?.variantId}:${cart?.quantity}`;
                    }
                });
                link += '?channel=buy_button';
                tempBundles[parentIdx].link_buy = link;

                setCardBundles(tempBundles);
            }
        }
    };

    const AddReduceCalc = ({ data, callback }: any) => {
        const NUM_MIN = data?.min || 0;
        const NUM_MAX = data?.inventory > data?.limit && data?.limit > 0 ? data?.limit : data?.inventory > 0 ? data?.inventory : 0;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 0);
        const [showMaxTip, setShowMaxTip] = useState(false);
        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number - 1,
                    button_name: '-',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (number >= NUM_MAX) {
                setShowMaxTip(true);
                setTimeout(() => {
                    setShowMaxTip(false);
                }, 2000);
                return false;
            }
            setNumber(number + 1);
            callback(data, number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number + 1,
                    button_name: '+',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v));
        };

        return (
            <div className="bundle-calculator GtmModuleData-section" data-section-id={'dpu-ProductBundles'} data-section-title={'dpu-ProductBundles'}>
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="24" height="24" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.545H15.7516C15.9291 12.545 16.0749 12.4939 16.1889 12.3916C16.303 12.2893 16.3601 12.1586 16.3601 11.9996C16.3601 11.8405 16.303 11.7098 16.1889 11.6075C16.0749 11.5052 15.9291 11.4541 15.7516 11.4541H8.24129C8.06381 11.4541 7.91804 11.5052 7.80395 11.6075C7.68986 11.7098 7.63281 11.8405 7.63281 11.9996C7.63281 12.1586 7.68986 12.2893 7.80395 12.3916C7.91804 12.4939 8.06381 12.545 8.24129 12.545Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {/* <div className="addSubtractor-number">{number}</div> */}
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="100%" height="100%" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.6088H11.388V15.7555C11.388 15.933 11.445 16.0788 11.5591 16.1929C11.6732 16.3069 11.819 16.364 11.9964 16.364C12.1739 16.364 12.3197 16.3069 12.4338 16.1929C12.5479 16.0788 12.6049 15.933 12.6049 15.7555V12.6088H15.7516C15.9291 12.6088 16.0749 12.5518 16.1889 12.4377C16.303 12.3236 16.3601 12.1778 16.3601 12.0004C16.3601 11.8229 16.303 11.6771 16.1889 11.563C16.0749 11.4489 15.9291 11.3919 15.7516 11.3919H12.6049V8.24519C12.6049 8.06772 12.5479 7.92194 12.4338 7.80785C12.3197 7.69376 12.1739 7.63672 11.9964 7.63672C11.819 7.63672 11.6732 7.69376 11.5591 7.80785C11.445 7.92194 11.388 8.06772 11.388 8.24519V11.3919H8.24129C8.06381 11.3919 7.91804 11.4489 7.80395 11.563C7.68986 11.6771 7.63281 11.8229 7.63281 12.0004C7.63281 12.1778 7.68986 12.3236 7.80395 12.4377C7.91804 12.5518 8.06381 12.6088 8.24129 12.6088Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {showMaxTip && <p className="reach-max">{s('reach_max')}</p>}
            </div>
        );
    };

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(bundles));
        const getAsynItem = async (productId: string, variantId: string, k: number, m?: number, type: 'subs' | 'installs' = 'subs') => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (m >= 0) {
                            if (!tempArr[k][type][m].name && (res?.data?.productTitle || res?.data?.skuTitle)) {
                                tempArr[k][type][m].name = res?.data?.skuTitle || res?.data?.productTitle;
                            }
                            if (!tempArr[k][type][m]?.img && res?.data?.img) {
                                tempArr[k][type][m].img = res?.data?.img;
                            }

                            if (!tempArr[k][type][m]?.title && res?.data?.skuTitle) {
                                tempArr[k][type][m].title = res?.data?.skuTitle || res.data?.productTitle;
                            }
                            tempArr[k][type][m].discountPrice = res?.data?.price;
                            tempArr[k][type][m].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                            tempArr[k][type][m].inventory = res?.data?.inventoryQuantity ?? undefined;
                            tempArr[k][type][m].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k][type][m].variantId}:1?channel=buy_button`;
                        } else {
                            if (!tempArr[k].name && (res?.data?.productTitle || res?.data?.skuTitle)) {
                                tempArr[k].name =
                                    res?.data?.skuTitle && res?.data?.skuTitle !== 'Default Title' ? res?.data?.skuTitle : res?.data?.productTitle;
                            }
                            if (variantImg && !tempArr[k]?.img && res?.data?.variantImg) {
                                tempArr[k].img = res?.data?.variantImg;
                            } else if (!tempArr[k]?.img && res?.data?.img) {
                                tempArr[k].img = res?.data?.img;
                            }
                            tempArr[k].discountPrice = res?.data?.price;
                            tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                            if (locale === 'ca' && pathname === '/delta-pro-ultra') {
                                tempArr[k].img = res?.data?.variantImg || res?.data?.img;
                            }
                            tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                            // tempArr[k].inventory = 1;
                            tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                            tempArr[k].link_learn_more = `https://${locale}.ecoflow.com/products/${res.data.handle}?variant=${res.data.variantId}`;
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        const promises = [];
        tempArr?.map((item: any, k: number) => {
            if (item?.variantId) {
                if (item?.subs?.length > 0 || item?.installs?.length > 0) {
                    promises.push(getAsynItem(item?.productId, item.variantId, k));
                    item?.subs?.map((sub: any, m: number) => promises.push(getAsynItem(sub?.productId, sub.variantId, k, m, 'subs')));
                    item?.installs?.map((install: any, m: number) => promises.push(getAsynItem(install?.productId, install.variantId, k, m, 'installs')));
                } else {
                    promises.push(getAsynItem(item?.productId, item.variantId, k));
                }
            }
        });

        // const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCardBundles(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    const handleLinkClick = (bundle: any) => {
        saveAICookieForShopify(bundle?.link_buy, locale);

        // if (locale === 'jp') {
        //     gtm.push({
        //         event: 'uaEvent',
        //         event_name: 'checkout',
        //         button_name: s('buy_now'),
        //         page_name: s('title'),
        //         product_name: t(bundle?.title),
        //     });
        // } else {
        //     gtm.push({
        //         event: 'uaEvent',
        //         event_name: 'buy',
        //         type: 'none',
        //         button_name: s('buy_now'),
        //         product_name: t(bundle?.title),
        //         position: 'Product Preview_Choose a Solution',
        //     });
        // }
    };

    const OldBuyComponent = ({ bundle }: any) =>
        bundle?.inventory > 0 && bundle?.link_buy ? (
            <Link
                className={`bundle-buy card-btn`}
                href={saveCookieForShopify(bundle?.link_buy, locale)}
                dataLayer={
                    locale === 'jp'
                        ? {
                              event: 'uaEvent',
                              event_name: 'checkout',
                              button_name: s('buy_now'),
                              page_name: 'EcoFlow DELTA Pro Ultra',
                              product_name: t(bundle?.title),
                          }
                        : {
                              event: 'uaEvent',
                              event_name: 'buy',
                              type: 'none',
                              button_name: s('buy_now'),
                              product_name: t(bundle?.title),
                              position: 'Product Preview_Choose a Solution',
                          }
                }
                onClick={() => handleLinkClick(bundle)}
            >
                {s('buy_now')}
            </Link>
        ) : (
            <button disabled className="bundle-buy disable">
                {s('sold_out')}
            </button>
        );
    return (
        <section className={`product-bundles ${css['product-bundles']}`}>
            <h1 className="title">{s('title')}</h1>
            <ul className="bundles">
                {(customize ? [...cardBundles, []] : cardBundles)?.map((bundle: any, k: number) => (
                    <li className={`bundle ${customize && k === cardBundles?.length ? 'customize' : ''}`} key={k}>
                        {customize && k === cardBundles?.length ? (
                            <div className="customize-bundle">
                                <p className="customize-subtitle">{s('customize_subtitle')}</p>
                                <p className="customize-title">{s('customize_title')}</p>
                                <Link
                                    className="customize-link"
                                    href={customize?.link}
                                    target={'_blank'}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_product',
                                        list_name: s('customize_title'),
                                        product_name: customize?.link,
                                        button_name: s('learn_more'),
                                        position: 'Product Preview_Choose a Solution',
                                    }}
                                >
                                    <span className="link-text">{s('learn_more')}</span>
                                    <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6.25651 2.35901L11.5898 7.69234L6.25651 13.0257"
                                            stroke="#3F68E0"
                                            strokeWidth="1.4"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                                <div className="customize-img">
                                    <EFPicture src={customize?.img} alt={s(customize?.title)} />
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="bundle-info">
                                    {bundle?.title && <p className="bundle-title">{t(bundle?.title)}</p>}
                                    <div className="bundle-img">
                                        <EFPicture src={bundle?.img} alt={t(bundle?.title)} />
                                    </div>
                                    {bundle?.name && <p className="bundle-name">{t(bundle?.name) || bundle?.name}</p>}
                                    {bundle?.power && <p className="bundle-power">{t(bundle?.power)}</p>}
                                    {bundle?.desc && <p className="bundle-desc">{t(bundle?.desc)}</p>}
                                    {bundle?.link && (
                                        <p className="bundle-link" onClick={() => callbackLink?.(bundle?.link?.type)}>
                                            {bundle?.link?.text}
                                        </p>
                                    )}
                                    {bundle?.button && (
                                        <p className="bundle-link" onClick={() => callbackButton?.(bundle?.button?.type)}>
                                            {bundle?.button?.text}
                                        </p>
                                    )}
                                    {bundle?.install_title && <p className="bundle-install-title">{t(bundle?.install_title)}</p>}
                                    {bundle?.install_link && (
                                        <a href={bundle?.install_link} target="_blank" rel="noreferrer">
                                            <p className="bundle-install-link">{t(bundle?.install_link_text)}</p>
                                        </a>
                                    )}
                                    {bundle?.carList && (
                                        <div className="bundle-car">
                                            {bundle.carList.map((item: any, idx: number) => (
                                                <div className="bundle-car-item" key={idx}>
                                                    <EFPicture className="bundle-car-img" src={item?.carImg} alt={t(item?.carText)} />
                                                    <div className="bundle-car-text">{item?.carText}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {bundle?.subs?.length > 0 && !ISDpuCa && (
                                        <ul className="bundle-subs">
                                            {bundle?.subsTitle && <p className="bundle-subs-title">{t(bundle?.subsTitle)}</p>}
                                            {bundle?.subs?.map((sub: any, m: number) => (
                                                <li
                                                    className="bundle-sub"
                                                    key={`${k}_${m}_${sub?.discountPrice}_${sub?.quantity}_${sub?.parentVariantId}_${sub?.variantId}`}
                                                >
                                                    <p className="bundle-sub-subtitle">{t(sub?.subtitle)}</p>
                                                    <div className="bundle-sub-content">
                                                        <div className="bundle-sub-img">
                                                            <EFPicture src={sub?.img} alt={t(sub?.title)} />
                                                        </div>
                                                        <div className="bundle-sub-info">
                                                            <p className="bundle-sub-title">{t(sub?.title) || sub.title}</p>
                                                            <div className="bundle-sub-price">
                                                                <span className="bundle-sub-discount-price">
                                                                    {FormatMoneyLocal(sub?.discountPrice, locale)}
                                                                </span>
                                                                {sub?.discountPrice !== sub?.originalPrice && (
                                                                    <span className="bundle-sub-original-price">
                                                                        {FormatMoneyLocal(sub?.originalPrice, locale)}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {sub?.discountPrice !== sub?.originalPrice && (
                                                                <p className="bundle-sub-save-price">
                                                                    {s('save')} {FormatMoneyLocal(sub?.originalPrice - sub?.discountPrice, locale)}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <AddReduceCalc data={sub} callback={(data: any, number: number) => handleCalculate(data, number, 'subs')} />
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {bundle?.installs?.length > 0 && (
                                        <ul className="bundle-subs">
                                            {bundle?.installs?.map((install: any, m: number) => (
                                                <li
                                                    className="bundle-sub"
                                                    key={`${k}_${m}_${install?.discountPrice}_${install?.quantity}_${install?.productId}_${install?.variantId}`}
                                                >
                                                    <p className="bundle-sub-subtitle">{t(install?.subtitle)}</p>
                                                    <div className="bundle-sub-content">
                                                        <div className="bundle-sub-img">
                                                            <EFPicture src={install?.img} alt={t(install?.title)} />
                                                        </div>
                                                        <div className="bundle-sub-info">
                                                            <p className="bundle-sub-title">{t(install?.title) || install.title}</p>
                                                            <div className="bundle-sub-price">
                                                                <span className="bundle-sub-discount-price">
                                                                    {FormatMoneyLocal(install?.discountPrice, locale)}
                                                                </span>
                                                                {install?.discountPrice !== install?.originalPrice && (
                                                                    <span className="bundle-sub-original-price">
                                                                        {FormatMoneyLocal(install?.originalPrice, locale)}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {install?.discountPrice !== install?.originalPrice && (
                                                                <p className="bundle-sub-save-price">
                                                                    {s('save')} {FormatMoneyLocal(install?.originalPrice - install?.discountPrice, locale)}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <AddReduceCalc
                                                        data={install}
                                                        callback={(data: any, number: number) => handleCalculate(data, number, 'installs')}
                                                    />
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                <div className="bundle-price">
                                    <div className="price-box">
                                        <p className="discount-price">{FormatMoneyLocal(bundle?.totalDiscount || bundle?.discountPrice, locale)}</p>
                                        {((bundle?.totalDiscount && bundle?.totalOriginal && bundle?.totalDiscount !== bundle?.totalOriginal) ||
                                            bundle?.discountPrice !== bundle?.originalPrice) && (
                                            <p className="original-price">{FormatMoneyLocal(bundle?.totalOriginal || bundle?.originalPrice, locale)}</p>
                                        )}
                                    </div>
                                    {bundle?.install && <p className="install">{t(bundle?.ship) || s('free_install')}</p>}
                                    {/* 外部自定义 buy now 按钮 */}
                                    {buyComponents ? buyComponents(bundle, <OldBuyComponent bundle={bundle} />) : <OldBuyComponent bundle={bundle} />}
                                </div>
                            </>
                        )}
                    </li>
                ))}
                {shipping && <p className="shipping">{t('bundles.shipping')}</p>}
            </ul>
        </section>
    );
}
